import * as angular from 'angular';
import { MobileBannerService } from './mobile-banner.service';

export const MobileBannerModule = angular.module('buildium.manager.mobile-banner', [])
    .service('MobileBannerService', MobileBannerService);
